import mixpanel from 'mixpanel-browser';

mixpanel.init(
    process.env.REACT_APP_MIXPANEL_TOKEN || '',
    {
        debug: process.env.NODE_ENV === 'development',
    }
);

export default mixpanel;